import axios from '../utils/axios';

export default function deleteCourseBrochure(adminId, data) {
    return (
        axios.post('/admin/' + adminId +'/courses/course/delete-brochure',  data )
    )
}
